import { render, staticRenderFns } from "./DataVisualization02.vue?vue&type=template&id=8eef6604&scoped=true&"
import script from "./dataVisualization02.js?vue&type=script&lang=js&"
export * from "./dataVisualization02.js?vue&type=script&lang=js&"
import style0 from "./DataVisualization02.vue?vue&type=style&index=0&id=8eef6604&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8eef6604",
  null
  
)

export default component.exports